"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var csx = require("../base/csx");
var styles_1 = require("../styles/styles");
var React = require("react");
var typestyle = require("typestyle");
var activeStyle = {
    backgroundImage: 'linear-gradient(#353434, #7B7B7B)',
    color: 'white',
};
var disabledStyle = {
    opacity: '.5',
};
var buttonBlackClassName = typestyle.style(csx.flexRoot, {
    fontFamily: 'sans-serif',
    fontWeight: 'bold',
    fontSize: '.6rem',
    transition: '.2s color, .2s opacity',
    color: styles_1.textColor,
    padding: '2px 3px',
    display: 'inline-flex',
    cursor: 'pointer',
    backgroundImage: 'linear-gradient(#7B7B7B, #353434)',
    border: '1px solid #464646',
    userSelect: 'none',
    outline: '0px',
}, {
    $nest: { '&:active': activeStyle }
});
exports.ButtonBlack = function (props) {
    var style = csx.extend(props.isActive ? activeStyle : {}, props.disabled ? disabledStyle : {});
    return React.createElement("button", { className: buttonBlackClassName, onClick: props.onClick, style: style, disabled: props.disabled }, props.text);
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/buttons.js
 ** module id = 82
 ** module chunks = 0
 **/